import cn from "classnames";
import { type PropsWithChildren } from "react";
import AnchorIf from "@/components/common/AnchorIf";
import type { ImageGalleryBlock } from "../types";
import { AnchorType } from "../constants";
import s from "./BaseImageBlock.module.css";

export interface BaseImageBlockProps {
  as: AnchorType;
  block: ImageGalleryBlock;
  lightbox: boolean;
}

export default function BaseImageBlock(
  props: PropsWithChildren<BaseImageBlockProps>,
) {
  const {
    block: {
      link: { url, openInNewTabEnabled },
    },
    as,
    lightbox,
    children,
  } = props;

  const className = cn(s.wrapper, {
    [s.pointer]: lightbox,
  });

  return (
    <AnchorIf
      href={as === AnchorType.Anchor ? url : ""}
      openInNewTab={openInNewTabEnabled}
      className={className}
    >
      {children}
    </AnchorIf>
  );
}
